var text10 = 'text-10';
var text12 = 'text-12';
var text14 = 'text-14';
var sizes = {
  xs: text10,
  sm: text12,
  md: text14
};

export { sizes };
//# sourceMappingURL=bullet.sizes.esm.js.map
